import React, { useState, useEffect, useRef, useCallback } from 'react'
import Link from '../Link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

import useDimensions from 'react-use-dimensions'
import useDragScroll from 'use-drag-scroll'
import useWindowSize from '../../hooks/useWindowSize'

import ArrowRight from '../../../assets/images/ArrowRight.svg'

import {
  scrollingCardsOuterContainer,
  scrollingCardsInnerContainer,
  scrollingCardsColumnContainer,
  scrollingCardsHeadingContainer,
  scrollingCardsColumn,
  scrollingCardsDark,
  scrollingCardsTextContainer,
  scrollingCardsImageContainer,
  scrollingCardsAltDisplay,
  scrollingCardsNormalImageContainer,
  scrollingCardsSpacer,
  scrollingCardsCtaLinkArrow,
} from './index.module.css'

import { isSvgOrGif } from '../../utils'

const ScrollingCards = ({
  title,
  components,
  isDarkTheme,
  hideTitle,
  backgroundColor,
  alternateDisplayMode,
}) => {
  const defaultBackgroundColor = isDarkTheme ? '#000000' : '#FFFFFF'
  const size = useWindowSize()
  const [isMobile, setIsMobile] = useState(false)
  const [isCenter, setIsCenter] = useState(true)
  const [ref, { height }] = useDimensions()
  const scrollableNodeRef = useRef()

  const { hasSwiped } = useDragScroll({
    sliderRef: scrollableNodeRef,
  })

  const LinkWrapper = ({ url, children }) => {
    return url ? (
      <Link
        to={url}
        onClick={(e) => {
          if (hasSwiped) {
            e.preventDefault()
          }
        }}
      >
        {children}
      </Link>
    ) : (
      <>{children}</>
    )
  }

  const getStyle = useCallback((ref) => {
    const styles = getComputedStyle(ref)
    return styles.overflow === 'hidden' ? true : false
  }, [])

  useEffect(() => {
    setIsMobile(size.width <= 510)
    setIsCenter(getStyle(scrollableNodeRef.current))
  }, [size.width])

  return (
    <div
      className={[
        isDarkTheme ? `${scrollingCardsDark} scrolling-cards-dark` : '',
        alternateDisplayMode ? scrollingCardsAltDisplay : '',
      ].join(' ')}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={['wrapper', scrollingCardsOuterContainer].join(' ')}>
        <div className={['container', scrollingCardsInnerContainer].join(' ')}>
          {(hideTitle === null || hideTitle === false) && (
            <div className={scrollingCardsHeadingContainer}>
              <h2>{title}</h2>
            </div>
          )}
          <SimpleBar
            scrollableNodeProps={{ ref: scrollableNodeRef }}
            style={{ height: height }}
          >
            <div
              ref={ref}
              className={scrollingCardsColumnContainer}
              style={{
                justifyContent: isCenter ? 'center' : 'flex-start',
              }}
            >
              {components &&
                components.map(
                  ({ ctaText, ctaUrl, title, image, superHeader }, index) => {
                    return (
                      <div className={scrollingCardsColumn} key={index}>
                        {image &&
                          (isSvgOrGif(image.file.url) ? (
                            <div
                              className={[
                                scrollingCardsImageContainer,
                                scrollingCardsNormalImageContainer,
                              ].join(' ')}
                            >
                              <Link
                                onClick={(e) => {
                                  if (hasSwiped) {
                                    e.preventDefault()
                                  }
                                }}
                                to={ctaUrl}
                              >
                                <img
                                  alt={image.description}
                                  src={image.file.url}
                                  style={{
                                    objectFit: 'contain',
                                    height:
                                      image.file.details.image.height >
                                      image.file.details.image.width
                                        ? '100%'
                                        : '',
                                  }}
                                />
                              </Link>
                            </div>
                          ) : (
                            <div className={scrollingCardsImageContainer}>
                              <Link
                                onClick={(e) => {
                                  if (hasSwiped) {
                                    e.preventDefault()
                                  }
                                }}
                                to={ctaUrl}
                              >
                                <GatsbyImage
                                  alt={image.description}
                                  image={getImage(
                                    isMobile
                                      ? image.scrollingCardsMobileImage
                                      : image.scrollingCardsImage
                                  )}
                                />
                              </Link>
                            </div>
                          ))}
                        <div className={scrollingCardsTextContainer}>
                          {superHeader && (
                            <span>
                              {
                                <LinkWrapper url={ctaUrl}>
                                  {superHeader}
                                </LinkWrapper>
                              }
                            </span>
                          )}
                          {title && (
                            <h3>
                              {<LinkWrapper url={ctaUrl}>{title}</LinkWrapper>}
                            </h3>
                          )}
                          {ctaText && ctaUrl && (
                            <Link to={ctaUrl}>
                              {ctaText}
                              <ArrowRight
                                className={scrollingCardsCtaLinkArrow}
                              />
                            </Link>
                          )}
                        </div>
                      </div>
                    )
                  }
                )}
              <div className={scrollingCardsSpacer}></div>
            </div>
          </SimpleBar>
        </div>
      </div>
    </div>
  )
}

export default ScrollingCards
